export default __webpack_public_path__ + "static/media/username.592b2701.png";